import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { ContractorHeadCountError } from '@constants/global.enum';

@Injectable({
  providedIn: 'root'
})
export class ContractorService {
   private baseUrl = `${environment.apiUrl}/hiring`;

  constructor(private http: HttpClient) {}

getContractorsHeadCount(employeeId: string, month: number, year: number): Observable<any> {
  const url = `${this.baseUrl}/contractors-count`;
  const params = { 
    employeeId: employeeId.toString(), 
    month: month.toString(), 
    year: year.toString() 
  };
  return this.http.get<any>(url, { params }).pipe(
    catchError(() => {
      alert(ContractorHeadCountError.FETCH_ERROR);
      return throwError(() => new Error(ContractorHeadCountError.THROW_ERROR));
    })
  );
}
}